// Mock data for TÆKNI portfolio website

export const COMPANY_NAME = "TÆKNI";

export const heroData = {
  title: "TÆKNI",
  tagline: "We craft digital experiences that feel like the future.",
  primaryCTA: "Contact Us",
  primaryLink: "/contact",
  secondaryCTA: "Our Process",
};

export const aboutPreview = {
  title: "About TÆKNI",
  description:
    "We are a forward-thinking digital studio that combines strategic thinking with innovative design to create exceptional digital experiences. Our team of creative technologists pushes boundaries to deliver solutions that don't just meet expectations—they redefine them.",
  link: "/about",
};

export const services = [
  {
    id: 1,
    title: "Branding",
    description:
      "Strategic brand development that captures essence and resonates with your audience. From identity systems to brand guidelines.",
    icon: "Sparkles",
  },
  {
    id: 2,
    title: "Web Design",
    description:
      "Stunning, user-centric interfaces that blend aesthetics with functionality. Modern, responsive, and built for conversion.",
    icon: "Layout",
  },
  {
    id: 3,
    title: "Development",
    description:
      "High-performance web applications built with cutting-edge technologies. Clean code, scalable architecture, seamless experiences.",
    icon: "Code",
  },
  {
    id: 4,
    title: "Strategy",
    description:
      "Data-driven digital strategies that align business goals with user needs. Research, planning, and execution excellence.",
    icon: "Target",
  },
  {
    id: 5,
    title: "Motion",
    description:
      "Dynamic animations and interactions that bring designs to life. Micro-interactions, transitions, and immersive experiences.",
    icon: "Zap",
  },
  {
    id: 6,
    title: "Consulting",
    description:
      "Expert guidance for your digital transformation journey. Technical audits, UX reviews, and strategic recommendations.",
    icon: "Lightbulb",
  },
];

export const projects = [
  {
    id: 1,
    title: "Apex Gym",
    category: "Gym Landing Page",
    description:
      "Apex Gym single-scroll demo website showcasing a basic HTML, CSS, and JavaScript landing experience.",
    image:
      "https://images.unsplash.com/photo-1518611012118-696072aa579a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxneW0lMjB3ZWJzaXRlfGVufDB8fHx8MTcwNTEzOTg5NA&ixlib=rb-4.1.0&q=85",
    year: "2024",
    tags: ["HTML", "CSS", "JavaScript", "Basic Website"],
  },
  {
    id: 2,
    title: "Quantum AI",
    category: "Branding & Identity",
    description:
      "Complete brand identity for an AI-powered analytics startup disrupting the data visualization space.",
    image:
      "https://images.unsplash.com/photo-1559028012-481c04fa702d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHx3ZWJzaXRlJTIwZGVzaWdufGVufDB8fHx8MTc2NTUxNzI5NHww&ixlib=rb-4.1.0&q=85",
    year: "2024",
    tags: ["Brand Identity", "Design System", "Motion"],
  },
  {
    id: 3,
    title: "Urban Canvas",
    category: "E-commerce",
    description:
      "A premium art marketplace connecting collectors with emerging artists worldwide.",
    image:
      "https://images.unsplash.com/photo-1680016661694-1cd3faf31c3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHx3ZWJzaXRlJTIwZGVzaWdufGVufDB8fHx8MTc2NTUxNzI5NHww&ixlib=rb-4.1.0&q=85",
    year: "2023",
    tags: ["E-commerce", "UX", "Payment Integration"],
  },
  {
    id: 4,
    title: "Velocity Sports",
    category: "Mobile App",
    description:
      "Real-time sports analytics and performance tracking for professional athletes.",
    image:
      "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHx3ZWJzaXRlJTIwZGVzaWdufGVufDB8fHx8MTc2NTUxNzI5NHww&ixlib=rb-4.1.0&q=85",
    year: "2023",
    tags: ["Mobile", "React Native", "Real-time"],
  },
  {
    id: 5,
    title: "Lumina Health",
    category: "Healthcare Platform",
    description:
      "HIPAA-compliant telemedicine platform connecting patients with healthcare providers seamlessly.",
    image:
      "https://images.unsplash.com/photo-1721466759653-5383d6be56cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwcG9ydGZvbGlvfGVufDB8fHx8MTc2NTUxNzI4OHww&ixlib=rb-4.1.0&q=85",
    year: "2023",
    tags: ["Healthcare", "Security", "WebRTC"],
  },
];

export const stats = [
  { id: 1, value: 150, suffix: "+", label: "Projects Delivered" },
  { id: 2, value: 98, suffix: "%", label: "Client Satisfaction" },
  { id: 3, value: 25, suffix: "+", label: "Countries Served" },
  { id: 4, value: 8, suffix: "", label: "Years of Excellence" },
];

export const testimonials = [
  {
    id: 1,
    quote:
      "ækni transformed our digital presence completely. Their strategic approach and attention to detail is unmatched.",
    author: "Sarah Chen",
    position: "CEO, Nexus Platform",
    company: "Nexus",
  },
  {
    id: 2,
    quote:
      "Working with TÆKNI was a game-changer. They didn't just build a product—they crafted an experience.",
    author: "Michael Rodriguez",
    position: "Founder, Quantum AI",
    company: "Quantum",
  },
  {
    id: 3,
    quote:
      "The team at TÆKNI brings a rare combination of creative vision and technical excellence. Highly recommended.",
    author: "Emma Thompson",
    position: "Head of Design, Urban Canvas",
    company: "Urban Canvas",
  },
];

export const teamMembers = [
  {
    id: 1,
    name: "Sanjay",
    role: "Founder",
    bio: "I focus on strategy and execution—turning vision into scalable, reliable outcomes. I believe strong teams build lasting products through clarity, consistency, and commitment. If you're driven by impact and results, we're aligned.",
    image: "/sanjay.jpeg",
  },
  {
    id: 2,
    name: "Vijay",
    role: "Founder",
    bio: "I'm a builder at heart—turning ideas into real, useful products. I believe in clean tech, honest design, and learning by doing. If you value purpose-driven innovation and growth, you're already part of my journey.",
    image: "/vijayanarayanan.jpeg",
  },
];

export const aboutContent = {
  philosophy: {
    title: "Our Philosophy",
    content:
      "At TÆKNI, we believe that exceptional digital experiences are born at the intersection of strategic thinking, innovative design, and technical mastery. We don't just build websites and apps—we craft digital ecosystems that drive business growth and create lasting impact.",
  },
  process: {
    title: "Our Process",
    steps: [
      {
        id: 1,
        title: "Discover",
        description:
          "Deep dive into your business, users, and market landscape to uncover opportunities.",
      },
      {
        id: 2,
        title: "Define",
        description:
          "Strategic planning and architecture that aligns stakeholders and sets clear direction.",
      },
      {
        id: 3,
        title: "Design",
        description:
          "Iterative design exploration combining aesthetics with user-centered thinking.",
      },
      {
        id: 4,
        title: "Develop",
        description:
          "High-quality implementation with clean code and best practices.",
      },
      {
        id: 5,
        title: "Deliver",
        description: "Launch, optimize, and support to ensure ongoing success.",
      },
    ],
  },
  values: [
    {
      id: 1,
      title: "Innovation First",
      description:
        "We constantly explore emerging technologies and design trends to stay ahead.",
    },
    {
      id: 2,
      title: "Quality Obsessed",
      description:
        "Every pixel, every line of code—we sweat the details that make experiences exceptional.",
    },
    {
      id: 3,
      title: "Client Partnership",
      description:
        "We're not vendors—we're partners invested in your long-term success.",
    },
    {
      id: 4,
      title: "Continuous Learning",
      description: "The digital landscape evolves rapidly. So do we.",
    },
  ],
};

export const contactInfo = {
  email: "taekni.0505@gmail.com",
  phone: "7200809026",
  address: "Injambakkam,chennai",
  social: {
    instagram:
      "https://www.instagram.com/taekni.io/?utm_source=qr&igsh=eHZscmp0YWkxZ3Fi#",
    linkedin: "https://www.linkedin.com/in/t%C3%A6kni-technology-studio/",
    twitter: "https://x.com/Taekni_io",
    github: "https://github.com/taekni0505",
  },
};

export const clients = [
  "Nexus",
  "Quantum",
  "Urban Canvas",
  "Velocity",
  "Lumina Health",
  "TechCorp",
  "DesignLab",
  "InnovateCo",
];

export const marqueeText = [
  "Branding",
  "Web Design",
  "Development",
  "Strategy",
  "Motion",
  "TÆKNI",
];
